import axios from "@/utils/request.js";

export function getMenuList(username){
    return axios.get('/plague/api/menu/show')
}
